import type { Theme } from '@emotion/react'
import { useLingui } from '@lingui/react'
import Cleave from 'cleave.js/react'

import { hasString, normalizeReactNode } from '@twisto/utils'

import { typographyVariant } from '../typography'

import type { InputProps } from './input-common'
import * as styles from './input.styles'

type Props = Omit<InputProps, 'onChange'>

export const StaticInput = ({
  border = true,
  value,
  placeholder,
  startAdornment,
  endAdornment,
  styles: stylesProp = {},
  formattedOptions,
}: Props) => {
  const {
    i18n: { locale },
  } = useLingui()

  const rootStyles = (theme: Theme) => [
    styles.root(theme),
    !border && styles.borderLess,
    typographyVariant.h3,
    stylesProp.root,
  ]

  const inputStyles = (theme: Theme) => [
    styles.input(theme),
    typographyVariant.h3,
    stylesProp.input,
  ]

  const startAdornmentStyles = [
    styles.startAdornment,
    stylesProp.startAdornment,
  ]

  const endAdornmentStyles = [styles.endAdornment, stylesProp.endAdornment]

  return (
    <div css={rootStyles}>
      {normalizeReactNode(startAdornment, {
        css: startAdornmentStyles,
      })}
      {formattedOptions ? (
        <Cleave
          key={locale}
          readOnly
          css={inputStyles}
          options={formattedOptions}
          placeholder={placeholder}
          value={value}
        />
      ) : (
        <div
          css={(theme) => [inputStyles(theme), { empty: !hasString(value) }]}
        >
          {value ?? placeholder}
        </div>
      )}
      {normalizeReactNode(endAdornment, {
        css: endAdornmentStyles,
      })}
    </div>
  )
}
